var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentGeneralDegreeofpref(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "graduation-hat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.308,
    height: 38.943,
    viewBox: "0 0 44.308 38.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_43870",
    "data-name": "Path 43870",
    d: "M119.558,124.9v10.073c0,4.206-7.347,6.49-14.279,6.49S91,139.179,91,134.973V124.9a1.3,1.3,0,0,1,1.3-1.3H118.26A1.3,1.3,0,0,1,119.558,124.9Zm0,0",
    transform: "translate(-83.125 -112.905)",
    fill: "#444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43871",
    "data-name": "Path 43871",
    d: "M270.279,124.9v10.073c0,4.206-7.347,6.49-14.279,6.49V123.6h12.981A1.3,1.3,0,0,1,270.279,124.9Zm0,0",
    transform: "translate(-233.846 -112.905)",
    fill: "#292929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43872",
    "data-name": "Path 43872",
    d: "M53.079,9.087a1.3,1.3,0,0,1-.831,1.22L31.392,18.1a1.436,1.436,0,0,1-.934,0L9.6,10.307V7.866L30.457.078a1.442,1.442,0,0,1,.934,0L52.248,7.866A1.3,1.3,0,0,1,53.079,9.087Zm0,0",
    transform: "translate(-8.771 0)",
    fill: "#6e6e6e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43873",
    "data-name": "Path 43873",
    d: "M278.154,9.087a1.3,1.3,0,0,1-.831,1.22L256.467,18.1a1.464,1.464,0,0,1-.467.078V0a1.473,1.473,0,0,1,.467.078l20.856,7.789A1.3,1.3,0,0,1,278.154,9.087Zm0,0",
    transform: "translate(-233.846 0)",
    fill: "#5a5a5a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43874",
    "data-name": "Path 43874",
    d: "M23.452,91.3a1.285,1.285,0,0,1-1.3,1.3H2.6V111.86l2.518,7.581a1.289,1.289,0,1,1-2.44.831l-.078-.233a1.335,1.335,0,0,1-1.3,1.116,1.285,1.285,0,0,1-1.3-1.3V91.3A1.285,1.285,0,0,1,1.3,90H22.154A1.285,1.285,0,0,1,23.452,91.3Zm0,0",
    transform: "translate(0 -82.211)",
    fill: "#fdbf00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentGeneralDegreeofpref);
export default __webpack_public_path__ + "static/media/student-general-degreeofpref.13638d7379e704a68f22bb3bb6e74cda.svg";
export { ForwardRef as ReactComponent };